import React from 'react';
import './Error.css';

const Error = ({ error }) => (
  <div className='error'>
    {`Error: ${error}`}
  </div>
);

export default Error;